
<div
  :data-component-name="$options.name"
  class="container h-100 d-flex"
  :class="[jel_getClassObject(content), { saviez_vous_que: isSaviezVous }]"
>
  <img v-if="image" v-lazy="jel_getFichierSrc(image)" class="w-100 image" :alt="content.titre" />
  <div class="div_container" :class="[isSaviezVous ? 'saviez_vous_ctn' : '']">
    <div
      class="mb-1 mt-2 titre_media graphik_bold"
      :style="{ color: content.couleurTitre }"
      v-html="content.titre"
    ></div>
    <div class="texte" v-html="content.texte"></div>
    <!-- TODO: M5 remplacement ici -->
    <!-- <a
      v-if="getMediaImageUrl(content)"
      :href="getMediaImageUrl(content)"
      class="stretched-link" 
    ></a -->
    <b-link
      v-if="!content.lien.field.includes('aucunLien')"
      v-bind="jel_getLienBinding(content.lien)"
    >
      <b-img-lazy :src="jel_getFichierSrc(image)" :alt="content.altImage" />
    </b-link>
  </div>
</div>
